module.exports = __webpack_public_path__ + "hyperion-v2-static/img/no_data_volcano.c949a882.png";